"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var core_link_1 = require("./core_link");
var lodash_1 = require("lodash");
var ArticleCollectionCard = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleCollectionCard, _super);
    function ArticleCollectionCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArticleCollectionCard.prototype.getCategoryName = function (article) {
        return lodash_1.get(article, 'articleCategories[0].name') ||
            lodash_1.get(article, 'categories[0].name');
    };
    ArticleCollectionCard.prototype.getURL = function (article) {
        return lodash_1.get(article, 'webLink.href') ||
            lodash_1.get(article, '_links.web.href');
    };
    ArticleCollectionCard.prototype.getImageURL = function (article) {
        return lodash_1.get(article, 'images[0].source') ||
            lodash_1.get(article, 'photo');
    };
    ArticleCollectionCard.prototype.getBackgroundImageStyle = function (article) {
        var src = this.getImageURL(article);
        if (!src)
            return null;
        return {
            backgroundImage: "url(" + src + ")",
            // this should be in image-box by default but isn't yet
            backgroundSize: 'cover',
        };
    };
    ArticleCollectionCard.prototype.renderSidebarPlaceholder = function () {
        return (React.createElement("div", { className: "article-collection-sidebar card article-collection-sidebar-card--placeholder" },
            React.createElement("div", { className: "image-box bg-offwhite" }),
            React.createElement("div", { className: "pl-1" },
                React.createElement("h4", { className: "size-90" }))));
    };
    ArticleCollectionCard.prototype.renderPlaceholder = function () {
        if (this.props.renderForSidebar)
            return this.renderSidebarPlaceholder();
        return (React.createElement("div", { className: "article-collection-card article-collection-card--placeholder" },
            React.createElement("div", { className: "article-collection-card__primary" },
                React.createElement("div", { className: "article-collection-card__img" }),
                React.createElement("h4", { className: "article-collection-card__title" }))));
    };
    ArticleCollectionCard.prototype.renderForSidebar = function () {
        var article = this.props.article;
        return (React.createElement(core_link_1.default, { className: "article-collection-sidebar-card", to: this.getURL(article), entityId: article.id },
            React.createElement("div", { className: "fx-width-25 mobile-fx-width-20" },
                React.createElement("div", { className: "image-box", style: this.getBackgroundImageStyle(article) })),
            React.createElement("div", { className: "pl-1" },
                React.createElement("h4", { className: "size-90" }, article.title))));
    };
    ArticleCollectionCard.prototype.render = function () {
        var article = this.props.article;
        if (!article)
            return this.renderPlaceholder();
        if (this.props.renderForSidebar)
            return this.renderForSidebar();
        return (React.createElement(core_link_1.default, { className: "article-collection-card", to: this.getURL(article), entityId: article.id },
            React.createElement("div", { className: "article-collection-card__primary" },
                React.createElement("div", { className: "article-collection-card__img", style: this.getBackgroundImageStyle(article) }),
                React.createElement("h4", { className: "article-collection-card__title" }, article.title)),
            React.createElement("div", { className: "article-collection-card__meta" },
                React.createElement("div", { className: "article-collection-card__category" }, this.getCategoryName(article)))));
    };
    return ArticleCollectionCard;
}(React.Component));
exports.default = ArticleCollectionCard;
//# sourceMappingURL=article_collection_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/article_collection_card.js
// module id = uHxV
// module chunks = 20 21